import {MI} from "../init";
import AbstractSymbol from "./AbstractSymbol";

/**
 * @constructor
 * @extends {AbstractSymbol}
 * @param {MadnesObject} sprite
 * @param {number} symbolNum
 * @param {number} reelX
 * @param {number} reelY
 */
export default function SymbolBook(sprite, symbolNum, reelX, reelY) {

    AbstractSymbol.call(this, sprite, symbolNum, reelX, reelY);

    /** @type {MadnesObject|null} */
    this._standShineObject;
    /** @type {MadnesObject|null} */
    this._bookLandObject;

    /** @type {MadnesObject|null} */
    this._winShineObject;
    /** @type {Function|null} */
    this._winAnimResolver;

    /** @type {MadnesObject|null} */
    this._fsListObject;

    // @type {Function|null} //
    //this._fsAnimResolver;

    /** @type {MadnesObject|null} */
    this._paperSprite;
    this._fsButtonEnabled = false;
};

SymbolBook.prototype = Object.create(AbstractSymbol.prototype);
SymbolBook.prototype.constructor = SymbolBook;

SymbolBook.prototype.paperType = {
    "random": 0,
    "shuffling": 1,
    "changing": 2
};

SymbolBook.shineColor = 0xff001e;

/**
 * @returns {number}
 */
SymbolBook.prototype.getShineColor = function() {
    return SymbolBook.shineColor;
};

SymbolBook.prototype.clear = function() {

    //this.parentSprite.setTexture("symbols_atlas");
    this._clearParentSprite();

    this.stopStandAnim();

    this._standShineObject = null;
    this._winAnimResolver = null;
    //this._fsAnimResolver = null;

    this.removeChilds();
};

/**
 * @override
 * @returns {AbstractSymbol}
 */
SymbolBook.prototype.createSymbol = function() {
    this.clear();
    this.createImage(0, 0, "symbols_atlas").setFrameName("symbol_Book");
    return this;
};

/**
 * @override
 * @returns {AbstractSymbol}
 */
SymbolBook.prototype.createSimpleSymbol = function() {
    return this.createSymbol();
};

SymbolBook.prototype.createStandAnim = function(/*visible*/) {
    this.clear();

    //visible = typeof visible !== "undefined" ? visible : false;

    this._standShineObject = this.createImage(3, 0, "symbol_Book_shine_atlas")
        .setBlend("ADD").setScale(2.5, 2.5); //.setVisible(visible);
    this._standShineObject.createAnims();
    this._standShineObject.anims.add("stand", MI.generateFrameNames("symbol_Book_shine_", 0, 23, "", 5));

    this.createImage(0, 0, "symbols_atlas").setFrameName("symbol_Book");
};

SymbolBook.prototype.playStandAnim = function() {
    if(!this._standShineObject) return;

    this._standShineObject.setVisible(true);
    this._standShineObject.anims.loop("stand", 26);
};

SymbolBook.prototype.stopStandAnim = function() {
    this._standShineObject && this._standShineObject.anims && this._standShineObject.anims.stop();
};

SymbolBook.prototype.fadeOutStandAnim = function() {};
SymbolBook.prototype.fadeInStandAnim = function() {};

SymbolBook.prototype.createLandAnim = function() {

    this._bookLandObject = this.createImage(0, 0, "multiplier_shine").setAlpha(0)
        .setBlend("ADD").setScale(.3, .3).setTint(0xf886a4);
};

SymbolBook.prototype.playLandAnim = function() {

    MI.addTween().to(this._bookLandObject, { 'x': 0.7, 'y': 0.7 }, {
        'scale': true,
        'duration': 800,
        'callback': function() {

            this._bookLandObject.destroy();

            //MI.addTween().to(m, )
        }.bind(this)
    });

    MI.addTween().to(this._bookLandObject, { 'alpha': 1 }, {
        //'delay': 450,
        'duration': 500,
        'yoyo': true
    });

    MI.addTween().to(this._bookLandObject, { 'angle': 100 }, {
        'duration': 800
    });

    //this._bookLandObject.anims.play("land");
};

SymbolBook.prototype.createWinSymbol = function() {
    this.createSymbol();

    this._winShineObject = this.createImage(0, 0, "symbol_Book_atlas")
        .setBlend("ADD").setScale(2, 2).setVisible(false).setAlpha(1);

    this._winShineObject.createAnims();
    this._winShineObject.anims.add("win", MI.generateFrameNames("symbol_Book_", 0, 19, "", 5));
    this._winShineObject.anims.addOnComplete(function() {
        this._winAnimResolver && this._winAnimResolver();
    }.bind(this));

    return this;
};

SymbolBook.prototype.playWinAnim = function() {

    return new Promise(function(res) {

        this._winAnimResolver = res;

        this._winShineObject.setVisible(true);
        this._winShineObject.anims.play("win");

    }.bind(this));
};

SymbolBook.prototype.stopWinAnim = function() {
    this._winAnimResolver = null;
    this._winShineObject.anims && this._winShineObject.anims.stop();
};

SymbolBook.prototype.destroyWinAnim = function() {
    this.stopWinAnim();
    this._winShineObject.destroy();
};

/**
 * @returns {SymbolBook}
 */
SymbolBook.prototype.createFSAnim = function() {
    //this.clear()

    this._fsListObject = this.createImage(0, 0, "symbol_Book_fs_atlas");
    //this._fsListObject.setScale(.76, .76);
    this._fsListObject.shiftPosX(3);
    this._fsListObject.createAnims();
    this._fsListObject.anims.add("fs", MI.generateFrameNames("symbol_Book_Free-spins_", 0, 30, "", 5));
    this._fsListObject.anims.addOnComplete(function() {
        this._fsListObject.anims.stop();
        this._fsListObject.destroy();
        //this._fsAnimResolver();
    }.bind(this));

    return this;
};

//listing in book anims
SymbolBook.prototype.playFSAnim = function() {

    return new Promise(function() {
        this._fsListObject.setVisible(true);
        this._fsListObject.anims.play("fs", 25);

    }.bind(this));
};

SymbolBook.prototype.stopFSAnim = function() {
    //this._fsAnimResolver = null;

    if(this._standShineObject) {
        this._standShineObject.anims && this._standShineObject.anims.stop();
        this._fsListObject.anims && this._fsListObject.anims.stop();
    }
};